import { ADD_SETTING, REMOVE_SETTING, ADD_REFRESH_HANDLER } from '../actions/setting'

const INITIAL_STATE = {
  settings: [],
  refreshHandlers: []
}

const setting = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_SETTING:
      return {
        ...state,
        settings: [...state.settings, action.setting]
      }

    case REMOVE_SETTING:
      return {
        ...state,
        settings: state.settings.filter(i => i !== action.setting)
      }

    case ADD_REFRESH_HANDLER:
      return {
        ...state,
        refreshHandlers: [...state.refreshHandlers, action.refreshHandler]
      }

    default:
      return state
  }
}

export default setting
